export enum MediatorEventType {
  WAGERPAD_CLICK = "HEADER:WAGERPAD_CLICK"
}
